import {$http} from '@/lib'
const account={
    namespaced: true,
    state:{
        
    },
    actions:{
        async isTenantAvailable(state:any,payload:any){
            let rep=await $http.post('/Authenticate/IsTenantAvailable',payload.data);
            return rep.data.result;
        }
    }
}
export default account;